import { Card, Typography } from 'antd';

export function RedirectCard({ title, description }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      padding: '24px',
    }}
    >
      <Card
        title={title}
        style={{
          maxWidth: '480px',
          width: '100%',
          borderRadius: '12px',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        }}
        styles={{
          header: {
            color: '#02862F',
            backgroundColor: '#DAEADE',
          },
          body: { padding: '24px' },
        }}
      >
        <Typography.Paragraph>{description}</Typography.Paragraph>
      </Card>
    </div>
  );
}
